import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '../../../core/components/Modal';
import { MagicWand } from '../../../icons';
import { Content, GoToSettingsButton, Message, SkipButton, Title } from './styles';
export default ({ onClose, onGoSettings }) => {
    return (React.createElement(Modal, { isOpen: true, "data-qa-anchor": "community-created-modal" },
        React.createElement(Content, null,
            React.createElement(MagicWand, null),
            React.createElement(Title, { "data-qa-anchor": "community-created-modal-title" },
                React.createElement(FormattedMessage, { id: "communityCreatedModal.title" })),
            React.createElement(Message, { "data-qa-anchor": "community-created-modal-message" },
                React.createElement(FormattedMessage, { id: "communityCreatedModal.message" })),
            React.createElement(GoToSettingsButton, { "data-qa-anchor": "community-created-modal-go-to-settings-button", onClick: onGoSettings },
                React.createElement(FormattedMessage, { id: "communityCreatedModal.goToSettings" })),
            React.createElement(SkipButton, { "data-qa-anchor": "community-created-modal-skip-button", onClick: onClose },
                React.createElement(FormattedMessage, { id: "communityCreatedModal.skip" })))));
};
//# sourceMappingURL=CommunityCreatedModal.js.map